import { KeyboardEvent as ReactKeyboardEvent, useCallback, useEffect, useRef, useState } from 'react';

import { MOBILE_NAVIGATION_BREAKPOINT } from 'components/Masthead/Header/types';

export const useBackdropMenu = () => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const openBtnRef = useRef<HTMLElement>(null);
  const closeBtnRef = useRef<HTMLElement>(null);

  const closeBackdrop = useCallback(() => {
    setBackdropOpen(false);
  }, []);

  const openBackdrop = useCallback(() => {
    setTouched(true);
    setBackdropOpen(true);
  }, []);

  const handleOnKeyDown = (e: ReactKeyboardEvent) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      if (backdropOpen) {
        closeBackdrop();
      } else {
        openBackdrop();
      }
    }
  };

  const handleOnEscapeKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeBackdrop();
      }
    },
    [closeBackdrop],
  );

  const handleResize = useCallback(() => {
    if (window.innerWidth > MOBILE_NAVIGATION_BREAKPOINT) {
      closeBackdrop();
    }
  }, [closeBackdrop]);

  useEffect(() => {
    if (backdropOpen) {
      document.body.classList.add('suppress-scroll');
      window.addEventListener('keydown', handleOnEscapeKeyDown, true);
      window.addEventListener('resize', handleResize, false);
    } else {
      document.body.classList.remove('suppress-scroll');
      window.removeEventListener('keydown', handleOnEscapeKeyDown, true);
      window.removeEventListener('resize', handleResize, false);
    }
  }, [backdropOpen, handleOnEscapeKeyDown, handleResize]);

  useEffect(() => {
    if (touched && !backdropOpen) {
      openBtnRef.current?.focus();
    } else {
      closeBtnRef.current?.focus();
    }
  }, [backdropOpen, touched]);

  return {
    backdropOpen,
    closeBtnRef,
    openBtnRef,
    closeBackdrop,
    openBackdrop,
    handleOnKeyDown,
  };
};
